export default __webpack_public_path__ + "static/lock-8964a58dd43ef60054e2db898faaa0c9.png";